import { Action } from '@ngrx/store';
import { InvoiceHierarchyItem } from '../reducers/reducers-avc-invoices';
import { InvoiceDownloadAPI } from '../../../../../redux/models/invoices/invoice-download-api';

export const GET_AVC_INVOICES = '[INVOICES] Get AVC Invoices';
export const GET_AVC_INVOICES_SUCCESS = '[INVOICES] Get AVC Invoices Success';
export const GET_AVC_INVOICES_ERROR = '[INVOICES] Get AVC Invoices Error';
export const GET_AVC_INVOICES_HIERARCHY = '[INVOICES] Get AVC Invoices Hierarchy';
export const GET_AVC_INVOICES_HIERARCHY_SUCCESS = '[INVOICES] Get AVC Invoices Hierarchy Success';

export class GetAvcInvoices implements Action {
  readonly type = GET_AVC_INVOICES;
  constructor(public officeId?: string) {}
}

export class GetAvcInvoicesSuccess implements Action {
  readonly type = GET_AVC_INVOICES_SUCCESS;
  constructor(public payload: InvoiceDownloadAPI.IInvoiceResponse[], public officeId?: string) {}
}

export class GetAvcInvoicesError implements Action {
  readonly type = GET_AVC_INVOICES_ERROR;
  constructor(public payload: string) {}
}

export class GetAvcInvoicesHierarchy implements Action {
  readonly type = GET_AVC_INVOICES_HIERARCHY;
  constructor() {}
}

export class GetAvcInvoicesHierarchySuccess implements Action {
  readonly type = GET_AVC_INVOICES_HIERARCHY_SUCCESS;
  constructor(public invoiceHierarchy: InvoiceHierarchyItem[]) {}
}

export type AvcInvoicesAction =
    GetAvcInvoices
  | GetAvcInvoicesSuccess
  | GetAvcInvoicesError
  | GetAvcInvoicesHierarchy
  | GetAvcInvoicesHierarchySuccess;
